"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.teaser.cta.label': '提问',
    'chat.teaser.default.prompt1.description': '火星的大气层是由什么构成的？',
    'chat.teaser.default.prompt1.text': '火星的大气层是由什么构成的？',
    'chat.teaser.default.prompt2.description': '马能跑多快？',
    'chat.teaser.default.prompt2.text': '马能跑多快？',
    'chat.teaser.default.prompt3.description': '如何更换爆胎？',
    'chat.teaser.default.prompt3.text': '如何更换爆胎？',
};
